<template>
  <section class="customers-say container no-left-padding" id="customers-say">
    <div class="p-right flex" v-animate-in>
      <div id="testimonials"></div>
      <div style="margin-top: 80px">
        <a style="margin-top: 80px">
          <h2 class="h3">Amit ügyfeleink mondtak rólunk</h2>
        </a>
        <p class="">
          Az Offie-nál büszkék vagyunk arra, hogy számtalan vállalkozásnak
          segítettünk megtalálni a tökéletes irodahelyiséget, ami pozitív
          hatással volt a budapesti üzleti közösségre. Hiszünk abban, hogy a
          megfelelő iroda a siker katalizátora lehet, és elkötelezettek vagyunk
          abban, hogy segítsük ügyfeleinket céljaik elérésében. Elkötelezettek
          vagyunk amellett, hogy hosszú távú kapcsolatokat építsünk ki
          ügyfeleinkkel, és hogy megbízható partnerek legyünk növekedésükben és
          sikerükben.
        </p>
      </div>
      <nav class="nav" v-if="customers.length > 4">
        <Button
          :disabled="!hasPrev"
          arrow="left"
          class="gray circle"
          @click="prev"
        ></Button>
        <Button
          :disabled="!hasNext"
          arrow="right"
          class="gray circle"
          @click="next"
        ></Button>
      </nav>
    </div>
    <div class=" " v-animate-in>
      <vue-horizontal
        :button="false"
        ref="horizontal"
        @scroll-debounce="onScroll"
      >
        <div
          v-for="(customer, key) in customers"
          :class="{
            customer: true,
            [customer.color]: true,
            'margin-0': customer.name === 'Károly Lovész'
          }"
          :key="key"
        >
          <a :href="customer.link" target="_blank" class="customer-container">
            <div class="customer-data">
              <img
                v-if="customer.pic"
                :src="require('@/assets/faces/' + customer.pic)"
                width="60"
                height="60"
                alt=""
              />
              <span>{{ customer.name }}</span>
            </div>
            <div class="customer-text">
              {{ customer.text }}
            </div>
            <div class="customer-position">{{ customer.sign }}</div>
          </a>
        </div>
      </vue-horizontal>
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "CustomersSay",
  components: {
    Button
  },
  data() {
    return {
      customers: this.$store.getters.getTestimonials,
      hasPrev: false,
      hasNext: true
    };
  },
  mounted() {},
  methods: {
    prev() {
      this.$refs.horizontal.prev();
    },
    next() {
      this.$refs.horizontal.next();
    },
    onScroll({ hasPrev, hasNext }) {
      this.hasPrev = hasPrev;
      this.hasNext = hasNext;
    }
  }
};
</script>

<style lang="scss">
.no-left-padding {
  padding-right: 0 !important;
}
.customers-say {
  // padding-top: 100px !important;
  .h3 {
    // margin: 0 16px 16px;
  }

  nav {
    display: none;
  }
  .p-right {
    padding-right: 16px !important;
  }

  .customer {
    // flex: 0 0 75%;
    //margin-right: 8px;
    margin: 0 0 0 16px;
    &-container {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      border-radius: 16px;
      box-sizing: border-box;
      padding: 24px;
      width: 100%;
      max-width: 250px;
      min-width: 200px;
      height: 100%;
      text-decoration: none;
    }

    &.black .customer-container {
      background: $black;
      color: $white;
    }
    &.blue .customer-container {
      background: $blue;
      background: $gradient;
      color: $white;
    }
    &.white .customer-container {
      background: $white;
      color: $black;
    }
    &.margin-0 {
      margin-right: 16px !important;
    }

    &-data {
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      img {
        border-radius: 50%;
        margin-right: 8px;
        width: 30px;
        height: 30px;
      }
      span {
        font-weight: 300;
        font-size: 19px;
        line-height: 30px;
      }
    }
    &-text {
      font-family: $title;
      font-size: 14px;
      line-height: 30px;
      margin-bottom: 32px;
      height: 100%;
    }
    &-position {
      font-weight: 300;
      font-size: 19px;
      line-height: 22px;
    }
  }

  @media screen and (min-width: $breakpoint) {
    margin: 0 0 200px;
    padding: 0 !important;

    nav {
      display: flex !important;
      align-items: end;
      gap: 5pxpx;
      margin-bottom: 19px;
      margin-right: -16px;

      .button {
        margin: 0 0 0 16px;
      }
    }

    .container {
      padding-top: 100px !important;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 0 auto 16px;
      .h3 {
        margin: 0;
      }
    }

    .vue-horizontal {
      --pad: calc(50vw - 565px);
      width: 100%;

      /* --gap: 0;
      --count: 3;
      --margin: 0; */
      .v-hl-container {
        padding-left: var(--pad);
      }
    }

    .customer {
      margin: 0 30px 0 0;
      // width: calc((100% - (var(--margin) * 2) + var(--gap)) / var(--count));
      // padding: 0 calc(var(--gap) / 2);
      width: 350px;
      &-container {
        margin: 0;
        // padding: 16px;
        max-width: 350px;
      }
      &-data {
        padding-bottom: 32px;
        span {
          font-size: 18px;
          line-height: 60px;
        }

        img {
          width: 60px;
          height: 60px;
        }
      }
      &-text {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 32px;
      }
      &-position {
        font-size: 16px;
        line-height: 24px;
      }
      &.margin-0 {
        margin-right: 0 !important;
      }
    }
  }
}
</style>
